import { FDStack } from '@facet-wealth/design';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import React from 'react';
import {
  TaxSavingsInRoadmapDisclosureSectionLayout,
} from 'Views/Page/Content/Templates/WizardTemplates/ScenarioSelectionRedefined/ScenarioSelectionRedefinedTaxStrategyStepTemplate/Content/Sections/TaxSavingsInRoadmapDisclosureSection/TaxSavingsInRoadmapDisclosureSectionLayout';
import {
  ProcessStepSectionLayout,
} from './ProcessStepSection/ProcessStepSectionLayout';
import {
  TaxSavingsSectionLayout,
} from './TaxSavingsSection/TaxSavingsSectionLayout';
import {
  TaxSavingsInRoadmapExplanationSectionLayout,
} from './TaxSavingsInRoadmapExplanationSection/TaxSavingsInRoadmapExplanationSectionLayout';
import { TaxSavingsChart } from './TaxSavingsChart';

const LAYOUTS = {
  ProposalScenarioTaxStrategyDetailsChartSection: TaxSavingsChart,
  ProposalScenarioTaxStrategyDetailsProcessStepSection: ProcessStepSectionLayout,
  ProposalScenarioTaxStrategyDetailsTaxSavingsSection: TaxSavingsSectionLayout,
  ProposalScenarioTaxStrategyDetailsTaxSavingsInRoadmapExplanationSection: TaxSavingsInRoadmapExplanationSectionLayout,
  ProposalScenarioTaxStrategyDetailDisclosureSection: TaxSavingsInRoadmapDisclosureSectionLayout,
};

const getLayout = (type) => {
  const layout = LAYOUTS[type];
  if (!layout) {
    throw new Error(`Did not find a layout for resource type ${type}!`);
  }
  return layout;
};

export const TaxStrategyDetailsSections = ({ collection, fixedWidth }) => {
  if (!collection) {
    return null;
  }
  return (
    <FDStack direction={'column'} spacing={6} paddingY={4} width={'100%'}>
      {collection.resources().list().map((section) => {
        const LayoutComponent = getLayout(section.type());
        return (
          <LayoutComponent resource={section} key={section.id()} fixedWidth={fixedWidth} />
        );
      })}
    </FDStack>
  );
};

TaxStrategyDetailsSections.propTypes = {
  collection: PropTypes.instanceOf(fr.Collection).isRequired,
};
